import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";
import GuideLine from "../Lines/GuideLine";

export class FlatOval extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'flat-oval', dimensions );
	}

	getRadius(): Length {
		return this.cleanedPrimitives.radius;
	}

	getLength(): Length {
		return this.cleanedPrimitives.width;
	}

	getHeight(): Length {
		return this.cleanedPrimitives.radius.multiply(2);
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width; // calculate with radius
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'width', secondary: 'radius' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		let dimensionLines = [];

		// Width of the straight part of the flat oval.
		const baseWidth = this.getWidth().subtract(this.getRadius().multiply(2));

		if(focusedElement.includes("cutout_measurement") || forceRender) {
			dimensionLines = [
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height', this.getHeight().in_cm() ), [-40, 0], ratio ),
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width', this.getWidth().in_cm() ), [0, -40], ratio, this.getDimensionLineType('measurements-flat-oval-width', focusedElement, forceRender) ),
				new DimensionLine( [ this.getRadius().in_mm(), this.getHeight().divide(2).in_mm() ], [ baseWidth.add(this.getRadius()).in_mm(), this.getHeight().divide(2).in_mm() ], this.renderDimensionLabel( 'width', baseWidth.in_cm() ), [0, 0], ratio ),
			];
		}

		if(focusedElement.includes("measurements-flat-oval-radius")) {
			dimensionLines.push(
				new DimensionLine( [ 0, this.getHeight().divide(2).in_mm() ], [ this.getRadius().in_mm(), this.getHeight().divide(2).in_mm() ], this.renderDimensionLabel( 'radius', this.getRadius().in_cm() ), [ 0, 0 ], ratio, this.getDimensionLineType('measurements-flat-oval-radius', focusedElement, forceRender) )
			);
		}

		return dimensionLines;
	}

	getGuideLines(focusedElement = ''): GuideLine[] {
		const baseWidth = this.getWidth().subtract(this.getRadius().multiply(2));

		return [
			new GuideLine( [ this.getRadius().in_mm(), 0 ], [ this.getRadius().in_mm(), this.getHeight().in_mm() ] ),
			new GuideLine( [ baseWidth.add(this.getRadius()).in_mm(), 0 ], [ baseWidth.add(this.getRadius()).in_mm(), this.getHeight().in_mm() ] ),
		];

	}

	getDefaultDimensions(): Dimensions {
		return {
			radius: 20,
			width: 100,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();

		return {
			width: width.divide(2).in_cm(),
			radius: width.divide(5).in_cm(),
		};
	}
}
